import Vue from 'vue'

Vue.mixin({
  methods: {
    notify(text, type = 'positive'){
      this.$q.notify({
        message: text,
        type: type,
        timeout: 3000
      })
    },
    axiosGet(uri, successCallback, loading = true, errorCallback, options){
      if(loading){
        this.$q.loading.show()
      }

      let promise = this.$axios.get(this.$apiUrl + uri, options);

      if(typeof successCallback === "function"){
        promise.then(successCallback);
      }

      promise.finally(() => {
        if(loading){
          this.$q.loading.hide()
        }

        if(typeof errorCallback === "function"){
          errorCallback()
        }
      })

      return promise
    },
    openLink(link) {
      if(typeof cordova === "undefined"){
        return window.open(link, '_blank')
      }

      cordova.InAppBrowser.open(link, '_system');
    },
    axiosPost(uri, data, successCallback, loading = true, errorCallback){
      if(loading){
        this.$q.loading.show()
      }

      let promise = this.$axios.post(this.$apiUrl + uri, data, data ? data.headers : undefined);

      if(typeof successCallback === "function"){
        promise.then(successCallback);
      }

      promise.finally(() => {
        if(loading){
          this.$q.loading.hide()
        }

        if(typeof errorCallback === "function"){
          errorCallback()
        }
      })

      return promise
    },
    setClientPageSubTitle(title){
      this.$store.commit('mainStore/title', {
        line_1: this.currentClient.full_name,
        line_2: title
      })
    },
    openClientProfile(client){
      this.$router.push('/client?id=' + client.id)
    },
  },
  computed: {
    requiredRules(){
      return [v => !!v || 'Value is required']
    },

    currentUser(){
      try {
        return this.$store.state.mainStore.user || {}
      } catch {
        return {}
      }
    }
  }
})
